document.addEventListener('DOMContentLoaded', function () {
  // Gallery thumb swap
  var mainImg = document.getElementById('pdp-main-img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
    });
  });

  // Option pills -> update hidden variant select
  var select = document.querySelector('[data-variant-select]');
  document.querySelectorAll('.pdp__option').forEach(function (optionGroup) {
    optionGroup.querySelectorAll('[data-option-select]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        optionGroup.querySelectorAll('[data-option-select]').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var label = optionGroup.querySelector('[data-option-value]');
        if (label) label.textContent = pill.getAttribute('data-value');
        // naive: rely on Shopify's variant select already reflecting first available match
        if (select) {
          var selectedValues = [];
          document.querySelectorAll('.pdp__option').forEach(function (grp) {
            var sel = grp.querySelector('.is-selected');
            selectedValues.push(sel ? sel.getAttribute('data-value') : null);
          });
          Array.from(select.options).forEach(function (opt) {
            var title = opt.textContent.trim();
            if (selectedValues.every(function (v) { return v && title.indexOf(v) !== -1; })) {
              select.value = opt.value;
            }
          });
        }
      });
    });
  });

  // Dispatch countdown is handled inline in sections/main-product.liquid (single guarded 4pm-cutoff timer).
  // The old midnight-cutoff timer here was removed because two timers writing to #pdp-timer made it flicker.
});
